import React from "react";
import CarouselHome from "../components/ComponentHome/CarouselHome";
import Footer from "../components/Footer";
import SectionComing from "./../components/ComponentHome/SectionComing";
import SectionHome from "./../components/ComponentHome/SectionHome";

const HomePage = () => {
  return (
    <div>
      <CarouselHome />
      <SectionHome />
      <SectionComing />
      <Footer />
    </div>
  );
};

export default HomePage;
